import { createContext } from 'react';

const OfferPanelContext = createContext({
  onViewOfferDetail: () => {},
  handleScribeSelectOffer: () => {},
  handleScribeApplyOffer: () => {},
  handleScribeContinueWithoutOffer: () => {},
  handleScribeOfferDetailDefault: () => {},
  handleScribeOfferDetailBack: () => {},
  handleScribeOfferDetailUseOffer: () => {},
  handleScribeEnterCodeDetailsBack: () => {},
  handleScribeEnterCodeDetailsTypeCode: () => {},
  handleScribeEnterCodeDetailsShowErrorResult: () => {},
  handleSelectOffer: () => {},
  setOfferConfig: () => {},
  errorMessage: '',
});

export default OfferPanelContext;
